export const OverallStatsIcon = ({
   width = 41,
   height = 41,
   stroke = 'white',
}: {
   width?: number
   height?: number
   stroke?: string
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 41 41"
      fill="none"
   >
      <path
         d="M16.1143 27.2435C21.3751 26.9514 25.5508 22.5932 25.5508 17.2595C25.5508 11.7366 21.0736 7.25946 15.5508 7.25946C10.0279 7.25946 5.55078 11.7366 5.55078 17.2595C5.55078 19.2273 6.11901 21.0623 7.10059 22.6094L6.39388 24.7295L6.39276 24.7327C6.12207 25.5447 5.98667 25.9509 6.08309 26.2213C6.1671 26.4569 6.35359 26.6426 6.58919 26.7266C6.85865 26.8227 7.26202 26.6882 8.0686 26.4194L8.08008 26.4159L10.2008 25.7092C11.748 26.6908 13.583 27.2592 15.5509 27.2592C15.74 27.2592 15.9278 27.2539 16.1143 27.2435ZM16.1143 27.2435C16.1145 27.2439 16.1142 27.2432 16.1143 27.2435ZM16.1143 27.2435C17.4826 31.136 21.1909 33.9264 25.551 33.9264C27.5189 33.9264 29.3535 33.3575 30.9005 32.3758L33.0208 33.0826L33.025 33.0834C33.8369 33.354 34.2438 33.4897 34.5142 33.3933C34.7498 33.3092 34.9339 33.1235 35.0179 32.8879C35.1145 32.6172 34.9794 32.2105 34.708 31.3962L34.0013 29.2761L34.238 28.8838C35.0737 27.4227 35.5499 25.73 35.5499 23.9261C35.5499 18.4033 31.0736 13.9261 25.5508 13.9261L25.1764 13.933L24.9876 13.9423"
         stroke={stroke}
         strokeWidth="1.5"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
   </svg>
)
